export default 'M1.94 10.56a1.5 1.5 0 0 0 2.12 0L8 6.62l3.94 3.94a1.5 1.5 0 0 0 2.12-2.12l-5-5a1.5 1.5 0 0 0-2.12 0l-5 5a1.5 1.5 0 0 0 0 2.12';